import { Skeleton } from 'antd';

export const WebchatSkeleton = () => {
    return (
        <>
            <div className="webchat-header">
                <Skeleton.Node style={{ width: 100, height: 32 }} />
            </div>
            <div className="webchat-message-list ant-bubble-list">
                <div className="ant-bubble-list-scroll-content">
                    <div
                        style={{
                            display: 'flex',
                            gap: 25,
                            alignItems: 'flex-start',
                            paddingBlock: 20,
                        }}>
                        <div className="ant-bubble-avatar">
                            <Skeleton.Button
                                block
                                style={{
                                    maxWidth: 60,
                                    height: 60,
                                    borderRadius: 60,
                                }}
                            />
                        </div>
                        <div className="ant-bubble-body" style={{ width: 265 }}>
                            <Skeleton.Button
                                block
                                style={{
                                    height: 90,
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="webchat-message-sender">
                <Skeleton.Button block style={{ height: 75 }} />
            </div>
        </>
    );
};
